import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { filter } from 'lodash';
import { useNavigate, NavLink } from 'react-router-dom';
import axios from 'axios';

import {
  Card,
  MenuItem,
  Stack,
  Row,
  Grid,
  Avatar,
  Box,
  Button,
  Popover,
  Checkbox,
  Modal,
  Typography,
  Container,
  TableContainer,
  TablePagination,
} from '@mui/material';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

import Loader from './loader/Loader';

console.log('ggg');

function createData(name, calories, fat, carbs, protein, detail) {
  return { name, calories, fat, carbs, protein, detail };
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}
const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3, 'Maecenas rutrum urna vel lacus viverra, id ultrices dui rutrum'),
  createData('Eclair', 262, 16.0, 24, 6.0, 'Morbi congue gravida nunc, eu cursus felis vulputate id'),
  createData(
    'Cupcake',
    305,
    3.7,
    67,
    4.3,
    'Vestibulum efficitur, ipsum consectetur finibus maximus, ligula dolor vehicula ex, sed viverra nulla mauris id purus'
  ),
  createData('Gingerbread', 356, 16.0, 49, 3.9, ' Suspendisse vehicula eu libero eget viverra'),
];

const ExpandableTableRow = ({ children, expandComponent, ...otherProps }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <>
      <TableRow {...otherProps}>
        <TableCell padding="checkbox">
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {children}
      </TableRow>
      {isExpanded && (
        <TableRow>
          <TableCell padding="checkbox" />
          {expandComponent}
        </TableRow>
      )}
    </>
  );
};

export default function SimpleTable() {
  const [opens, setOpens] = React.useState(false);
  const handleOpen = () => setOpens(true);
  const handleClose = () => setOpens(false);
  const navigate = useNavigate();
  // console.log(USERLISTA);
  const [USERLIST, setgroupwisemember] = useState([]);
  const [MEMBERLIST, setmemberlist] = useState([]);
  const [useredit, setuseredit] = useState('');
  const [userdelete, setuserdelete] = useState('');
  const [isLoader, setIsLoader] = useState(true);
  // const [codevalue, setcodeValue] = useState([]);
  useEffect(() => {
    fetchuser();
  }, []);
  const fetchuser = () => {
    axios
      .post(
        '/api/group_wise_group_member_details',
        {},
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        setgroupwisemember(response.data.groupwisemember);
        setIsLoader(false);
        // console.log(response.data.userlist);
        console.log(USERLIST);
      })
      .catch((err) => {
        console.log(err);
        setIsLoader(false);
      });
  };

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setuseredit(event.currentTarget.value);
    setuserdelete(event.currentTarget.value);
  };
  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);
  // console.log('filter', filteredUsers);

  const isNotFound = !filteredUsers.length && !!filterName;
  return (
    <>
      {isLoader ? (
        <Loader />
      ) : (
        <>
          <Container className="userlist-table">
            <Card>
              <UserListToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
              />
              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox" />
                        <TableCell>Group Code</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Bank name</TableCell>

                        <TableCell>Branch name</TableCell>
                        <TableCell>Block Name</TableCell>
                        <TableCell>Gp Name</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {/* {rows.map(row => (
            <React.Fragment key={row.name}>
              <TableRow>
                <TableCell padding="checkbox">
                  <IconButton>
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="right">{row.calories}</TableCell>
                <TableCell align="right">{row.fat}</TableCell>
                <TableCell align="right">{row.carbs}</TableCell>
                <TableCell align="right">{row.protein}</TableCell>
              </TableRow>
            </React.Fragment>
          ))} */}
                      {USERLIST.map((row) => (
                        <ExpandableTableRow
                          scope="row"
                          key={row.code}
                          expandComponent={
                            <>
                              <Table aria-label="simple table">
                                <TableHead>
                                  <TableRow className="tablerow">
                                    <TableCell width="30%" align="right">
                                      Member Name
                                    </TableCell>
                                    <TableCell width="70%" align="right">
                                      Member Age
                                    </TableCell>
                                    <TableCell align="right">Caste</TableCell>
                                    <TableCell align="right">Phone No</TableCell>
                                    <TableCell align="right">Insurance</TableCell>
                                  </TableRow>
                                </TableHead>
                                {row.memberdetails.map((member) => (
                                  <>
                                    <TableBody className="tablecell">
                                      <TableCell>{member.membername}</TableCell>
                                      <TableCell>{member.memberage}</TableCell>
                                      <TableCell>{member.caste}</TableCell>
                                      <TableCell>{member.phno}</TableCell>
                                      <TableCell>{member.insurance}</TableCell>
                                    </TableBody>
                                  </>
                                ))}
                              </Table>
                            </>
                          }
                        >
                          <TableCell component="th" scope="row">
                            {row.groupcode}
                          </TableCell>
                          <TableCell>{row.groupname}</TableCell>
                          <TableCell>{row.bankname}</TableCell>
                          <TableCell>{row.branchname}</TableCell>
                          <TableCell>{row.blockname}</TableCell>
                          <TableCell>{row.groupname}</TableCell>
                        </ExpandableTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100, { value: -1, label: 'all' }]}
                component="div"
                count={USERLIST.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
          </Container>
          <Popover
            open={Boolean(open)}
            anchorEl={open}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                p: 1,
                width: 140,
                '& .MuiMenuItem-root': {
                  px: 1,
                  typography: 'body2',
                  borderRadius: 0.75,
                },
              },
            }}
          >
            <MenuItem onClick={handleOpen}>
              <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
              Member Details
            </MenuItem>
          </Popover>
        </>
      )}
    </>
  );
}
